import { ORDER_CREATE_FAIL, ORDER_CREATE_REQUEST, ORDER_CREATE_RESET, ORDER_CREATE_SUCCESS, ORDER_PAYMENT_SUCCESS } from '../Constants/orderConstants';

export const orderCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_CREATE_REQUEST:
      return { loading: true };
    case ORDER_CREATE_SUCCESS:
      return { 
        loading: false, 
        success: true, 
        orderId: action.payload.orderId,
        paymentMethod: action.payload.paymentMethod,
        totalAmount: action.payload.totalAmount
      };
    case ORDER_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case ORDER_PAYMENT_SUCCESS:
      return { 
        ...state, 
        paymentSuccess: true, 
        paymentData: action.payload 
      };
    case ORDER_CREATE_RESET:
      return {};
    default:
      return state;
  }
};
